/**
 * Appends a referral parameter to external URLs
 * @param url - The URL to append the referral parameter to
 * @param ref - The referral value (defaults to "simplefeed.com")
 * @returns The URL with the referral parameter appended
 */
export function addReferralParam(
	url: string,
	ref: string = "simplefeed.com",
): string {
	if (!url) return url;

	try {
		const urlObj = new URL(url);
		// Only append ref if it's an external URL (not same origin)
		// Check if it's not a relative path or same origin
		if (urlObj.origin !== window.location.origin) {
			urlObj.searchParams.set("referrer", ref);
			return urlObj.toString();
		}
		// Return original URL if it's same origin or relative
		return url;
	} catch {
		// If URL parsing fails (e.g., relative path or invalid URL), return as-is
		// For relative paths, we don't want to add ref parameter
		return url;
	}
}
